import { create } from "zustand";
import { Offer } from "@/types/offer";

type OfferState = {
  pendingOffer: Offer | null;
  shouldShowSuccessModal: boolean;
  setPendingOffer: (_offer: Offer) => void;
  triggerSuccessModal: () => void;
  clearSuccessModal: () => void;
  clearPendingOffer: () => void;
};

const useOfferStore = create<OfferState>((set) => ({
  pendingOffer: null,
  shouldShowSuccessModal: false,
  setPendingOffer: (offer) => set({ pendingOffer: offer }),
  triggerSuccessModal: () => set({ shouldShowSuccessModal: true }),
  clearSuccessModal: () =>
    set({ pendingOffer: null, shouldShowSuccessModal: false }),
  clearPendingOffer: () => set({ pendingOffer: null }),
}));

export default useOfferStore;
